module.exports = __webpack_public_path__ + "img/72_24.ca865c90.png";